module.exports = __webpack_public_path__ + "img/elite_greige_ba_list.10db0f5d.jpg";